import { memo, useEffect } from 'react';
import { motion, useAnimationControls } from 'framer-motion';
import { ROAD_MAP_COLORS } from '../../../lobby/constants';
type SmallRoadCellProps = {
    win: number;
};
const SmallRoadAnimatedCell = ({ win }: SmallRoadCellProps) => {
    const askRoadAnimation = useAnimationControls();
    const anim = () => {
        askRoadAnimation.start({
            opacity: [1, 1, 0, 1, 1, 0],
            transition: { duration: 1 },
        });
    };
    useEffect(() => {
        anim();
    }, []);
    return (
        <svg viewBox="0 0 12 12" className="roadmap-cell">
            <motion.circle
                animate={askRoadAnimation}
                initial={{ opacity: 0 }}
                cx="6"
                cy="6"
                r="6"
                fill={win == 0 ? ROAD_MAP_COLORS.RED : ROAD_MAP_COLORS.BLUE}
            />
        </svg>
    );
};
export default memo(SmallRoadAnimatedCell);
